export default function transformValue(value, type) {
  if (value === null) {
    return null;
  }

  switch (type) {
    case "number":
      return Number(value);
    case "date":
      return new Date(`${value}T00:00:00`);
    case "datetime":
      return new Date(value);
    case "time": {
      // Accept formats like "00:00:00.0000" and "00:00:00"
      const [hh, mm, ssWithMs] = String(value).split(":");
      const ss = ssWithMs ? ssWithMs.split(".")[0] : "0";
      const hhNum = Number(hh);
      const mmNum = Number(mm);
      const ssNum = Number(ss);

      const valid =
        Number.isInteger(hhNum) &&
        hhNum >= 0 &&
        hhNum <= 23 &&
        Number.isInteger(mmNum) &&
        mmNum >= 0 &&
        mmNum <= 59 &&
        Number.isInteger(ssNum) &&
        ssNum >= 0 &&
        ssNum <= 59;

      if (!valid) {
        throw new Error(`Invalid time value: ${value}`);
      }

      const d = new Date(0);
      d.setHours(hhNum, mmNum, ssNum, 0);
      return d;
    }
    case "boolean":
      return Boolean(value);
    case "string":
      return String(value);
    case "json":
    case "array":
      return value;
    default:
      throw new Error(`${type} is not a valid option in transformValue`);
  }
}
